module.exports = __webpack_public_path__ + "img/TSGLadestationNotAus.fa2db77f.png";